module.exports = __webpack_public_path__ + "img/manage-talent.aed261e4.svg";